import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";

import { Button, Text, H3, H2, H4, Dropdown, Panel, Table } from '@bigcommerce/big-design';
import { ArrowDropDownIcon, RestoreIcon } from '@bigcommerce/big-design-icons';

import ToolPage from '../partials/ToolPage';
import PdfPreview from '../partials/PdfPreview';
import { indexBarcodeTemplates, previewBarcodeTemplate, previewBarcodeTemplateFailure, clearBarcodePreview, getTemplateFungibles, getTemplateLineSettings } from '../../redux/actions/barcodeTemplates';
import { searchProductBarcodeValue, downloadBarcodePreview, productCustomFields } from '../../redux/actions/products';

import LoadingPlaceholder from '../partials/LoadingPlaceholder';
import NoLabelTemplatesBox from '../partials/NoLabelTemplatesBox';

const BarcodeActions = ({ payload, getByBarcodeValue, getTemplates, activeBarcode, barcodeTemplates, loadPreview, previewFailed, clearPreview, downloadPreview, downloadUrl, products, templateFungibles, templateLineSettings, loadFungibles, loadLineSettings, getCustomFields, customFields }) => {
  let { barcode, brand } = useParams();

  const [activeTemplate, setActiveTemplate] = useState({});
  const [previewWaiting, setPreviewWaiting] = useState(false);

  const [downloadSubmitted, setDownloadSubmitted] = useState(false);

  const requestPreview = (template) => {
    setPreviewWaiting(true);
    loadPreview(payload, template, activeBarcode, customFields[0]?.custom_fields);
  }

  useEffect(() => {
    getTemplates(payload);
    getByBarcodeValue(payload, barcode);

    return () => clearPreview();
  }, []);

  useEffect(() => {
    if(activeBarcode) {
      getCustomFields(payload, [activeBarcode.related_product_id]);
    }
  }, [activeBarcode]);

  useEffect(() => {
    if(downloadUrl && downloadSubmitted) { 
      setDownloadSubmitted(false); 
      let win = window.open(downloadUrl, '_blank');
      win.focus();
    }
  }, [downloadUrl]);

  useEffect(() => {
    if(templateFungibles && templateLineSettings && barcodeTemplates.fungiblesLoaded && barcodeTemplates.lineSettingsLoaded) {

      let updatedTemplate = activeTemplate;
      updatedTemplate['barcode_enabled'] = templateFungibles[activeTemplate['barcode_element_uuid']]['enabled'];
      updatedTemplate['barcode_line'] = templateFungibles[activeTemplate['barcode_element_uuid']]['line'];
      updatedTemplate['barcode_symbol_enabled'] = templateFungibles[activeTemplate['barcode_symbol_element_uuid']]['enabled'];
      updatedTemplate['barcode_symbol_line'] = templateFungibles[activeTemplate['barcode_symbol_element_uuid']]['line'];
      updatedTemplate['barcode_symbol_priority'] = templateFungibles[activeTemplate['barcode_symbol_element_uuid']]['priority'];
      updatedTemplate['barcode_symbol_label_enabled'] = templateFungibles[activeTemplate['barcode_symbol_element_uuid']]['label_enabled'];
      updatedTemplate['barcode_symbol_label_override'] = templateFungibles[activeTemplate['barcode_symbol_element_uuid']]['label_override'];
      updatedTemplate['product_name_enabled'] = templateFungibles[activeTemplate['product_name_element_uuid']]['enabled'];
      updatedTemplate['product_name_line'] = templateFungibles[activeTemplate['product_name_element_uuid']]['line'];
      updatedTemplate['product_name_priority'] = templateFungibles[activeTemplate['product_name_element_uuid']]['priority'];
      updatedTemplate['product_name_label_enabled'] = templateFungibles[activeTemplate['product_name_element_uuid']]['label_enabled'];
      updatedTemplate['product_name_label_override'] = templateFungibles[activeTemplate['product_name_element_uuid']]['label_override'];
      updatedTemplate['option_1_enabled'] = templateFungibles[activeTemplate['option_1_element_uuid']]['enabled'];
      updatedTemplate['option_1_line'] = templateFungibles[activeTemplate['option_1_element_uuid']]['line'];
      updatedTemplate['option_1_priority'] = templateFungibles[activeTemplate['option_1_element_uuid']]['priority'];
      updatedTemplate['option_1_label_enabled'] = templateFungibles[activeTemplate['option_1_element_uuid']]['label_enabled'];
      updatedTemplate['option_1_label_override'] = templateFungibles[activeTemplate['option_1_element_uuid']]['label_override'];
      updatedTemplate['option_2_enabled'] = templateFungibles[activeTemplate['option_2_element_uuid']]['enabled'];
      updatedTemplate['option_2_line'] = templateFungibles[activeTemplate['option_2_element_uuid']]['line'];
      updatedTemplate['option_2_priority'] = templateFungibles[activeTemplate['option_2_element_uuid']]['priority'];
      updatedTemplate['option_2_label_enabled'] = templateFungibles[activeTemplate['option_2_element_uuid']]['label_enabled'];
      updatedTemplate['option_2_label_override'] = templateFungibles[activeTemplate['option_2_element_uuid']]['label_override'];
      updatedTemplate['option_3_enabled'] = templateFungibles[activeTemplate['option_3_element_uuid']]['enabled'];
      updatedTemplate['option_3_line'] = templateFungibles[activeTemplate['option_3_element_uuid']]['line'];
      updatedTemplate['option_3_priority'] = templateFungibles[activeTemplate['option_3_element_uuid']]['priority'];
      updatedTemplate['option_3_label_enabled'] = templateFungibles[activeTemplate['option_3_element_uuid']]['label_enabled'];
      updatedTemplate['option_3_label_override'] = templateFungibles[activeTemplate['option_3_element_uuid']]['label_override'];
      updatedTemplate['price_enabled'] = templateFungibles[activeTemplate['price_element_uuid']]['enabled'];
      updatedTemplate['price_line'] = templateFungibles[activeTemplate['price_element_uuid']]['line'];
      updatedTemplate['price_priority'] = templateFungibles[activeTemplate['price_element_uuid']]['priority'];
      updatedTemplate['price_label_enabled'] = templateFungibles[activeTemplate['price_element_uuid']]['label_enabled'];
      updatedTemplate['price_label_override'] = templateFungibles[activeTemplate['price_element_uuid']]['label_override'];
      updatedTemplate['brand_enabled'] = templateFungibles[activeTemplate['brand_element_uuid']]['enabled'];
      updatedTemplate['brand_line'] = templateFungibles[activeTemplate['brand_element_uuid']]['line'];
      updatedTemplate['brand_priority'] = templateFungibles[activeTemplate['brand_element_uuid']]['priority'];
      updatedTemplate['brand_label_enabled'] = templateFungibles[activeTemplate['brand_element_uuid']]['label_enabled'];
      updatedTemplate['brand_label_override'] = templateFungibles[activeTemplate['brand_element_uuid']]['label_override'];

      updatedTemplate['mpn_enabled'] = templateFungibles[activeTemplate['mpn_element_uuid']]['enabled'];
      updatedTemplate['mpn_line'] = templateFungibles[activeTemplate['mpn_element_uuid']]['line'];
      updatedTemplate['mpn_priority'] = templateFungibles[activeTemplate['mpn_element_uuid']]['priority'];
      updatedTemplate['mpn_label_enabled'] = templateFungibles[activeTemplate['mpn_element_uuid']]['label_enabled'];
      updatedTemplate['mpn_label_override'] = templateFungibles[activeTemplate['mpn_element_uuid']]['label_override'];

      updatedTemplate['bpn_enabled'] = templateFungibles[activeTemplate['bpn_element_uuid']]['enabled'];
      updatedTemplate['bpn_line'] = templateFungibles[activeTemplate['bpn_element_uuid']]['line'];
      updatedTemplate['bpn_priority'] = templateFungibles[activeTemplate['bpn_element_uuid']]['priority'];
      updatedTemplate['bpn_label_enabled'] = templateFungibles[activeTemplate['bpn_element_uuid']]['label_enabled'];
      updatedTemplate['bpn_label_override'] = templateFungibles[activeTemplate['bpn_element_uuid']]['label_override'];

      updatedTemplate['line_settings'] = templateLineSettings;

      setActiveTemplate(updatedTemplate);

      activeBarcode.brand = brand;

      requestPreview(updatedTemplate);
    }
  }, [templateFungibles, templateLineSettings]);

  const switchActiveTemplate = (event) => {
    let template = barcodeTemplates.templates.find(template => template.uuid === event.hash);

    loadFungibles(payload, event.hash);
    loadLineSettings(payload, event.hash);

    setActiveTemplate(template);
    clearPreview();
  }

  const handleDownload = () => {
    setDownloadSubmitted(true);
    downloadPreview(payload);
  }

  const templates = () => {
    let templateItems = [];

    barcodeTemplates.templates.map(template => 
      templateItems.push(
        {
          content: template.template_name,
          onItemClick: (event) => switchActiveTemplate(event),
          hash: template.uuid
        }
      )
    )

    return templateItems;
  }

  const tableItems = () => {
    let items = [];

    items.push({ property: 'Barcode Value', value: barcode });
    items.push({ property: 'Product Name', value: activeBarcode.name });
    activeBarcode.option_values?.map(option =>
      items.push({ property: option.option_display_name, value: option.label })
    )

    return items;
  }

  if(barcodeTemplates.status === 'success' && activeBarcode) {
    return(
      <>
        <ToolPage title="Barcode Actions" helpLink="bigcommerce/print-barcode-labels/">
          <Panel>
            <H2>Preview With Template</H2>
            { barcodeTemplates.templates.length === 0 && 
              <NoLabelTemplatesBox/>
            }
            { barcodeTemplates.templates.length > 0 &&
              <>
                <H4>Template</H4>
                <Dropdown
                  items={templates()}
                  maxHeight={250}
                  placement="bottom-start"
                  toggle={<Button iconRight={<ArrowDropDownIcon />}>{activeTemplate?.template_name || 'Template'}</Button>}
                />
              </>
            }
            <hr/>
            <div className="info-background">
              <div className="preview-header">
                <H3>Preview</H3>
                { (Object.keys(activeTemplate).length > 0) &&
                  <Button variant="secondary" iconLeft={<RestoreIcon />} onClick={() => requestPreview(activeTemplate)}>Refresh</Button>
                }
              </div>
              { (Object.keys(activeTemplate).length > 0) &&
                <>
                  <PdfPreview
                    uri={barcodeTemplates.previewUri}
                    loading={previewWaiting}
                    onReady={() => setPreviewWaiting(false)}
                    onError={() => { setPreviewWaiting(false); previewFailed(); }}
                  />
                  { barcodeTemplates.previewUri &&
                    <>
                      { !downloadSubmitted && <div className="top-15"><Button onClick={() => handleDownload()}>Download Preview</Button></div> }
                      { downloadSubmitted && <div className="top-15"><Button disabled>Download Preview</Button></div> }
                    </>
                  }
                </>
              }
              { (Object.keys(activeTemplate).length === 0) &&
                <Text color="secondary60">Select template to preview</Text>
              }
            </div>
            <hr/>
            <Table
              columns={[
                { header: 'Item Property', hash: 'property', render: ({ property }) => property },
                { header: 'Value', hash: 'value', render: ({ value }) => value }
              ]}
              items={tableItems()}
            />
          </Panel>
        </ToolPage>
      </>
    )
  }


  return (
    <>
      <ToolPage title="Barcode Actions" helpLink="bigcommerce/print-barcode-labels/">
        <LoadingPlaceholder title="Barcode Actions"/>
      </ToolPage>
    </>
  )
}

const mapStateToProps = state => ({
  products: state.products,
  searchedBarcodes: state.products.searchedBarcodes,
  barcodeTemplates: state.barcodeTemplates,
  activeBarcode: state.products.activeBarcode,
  downloadUrl: state.products.downloadUrl,
  templateFungibles: state.barcodeTemplates.templateFungibles,
  templateLineSettings: state.barcodeTemplates.templateLineSettings,
  settings: state.settings.settings,
  customFields: state.products.customFields,
});


const mapDispatchToProps = (dispatch) => ({
  getByBarcodeValue: (payload, barcodeValue) => dispatch(searchProductBarcodeValue(payload, barcodeValue)),
  getTemplates: (payload) => dispatch(indexBarcodeTemplates(payload)),
  loadPreview: (payload, options, values, customFields) => dispatch(previewBarcodeTemplate(payload, options, values, customFields)),
  previewFailed: () => dispatch(previewBarcodeTemplateFailure()),
  clearPreview: () => dispatch(clearBarcodePreview()),
  downloadPreview: (payload, customFields) => dispatch(downloadBarcodePreview(payload, customFields)),
  loadFungibles: (payload, uuid) => dispatch(getTemplateFungibles(payload, uuid)),
  loadLineSettings: (payload, uuid) => dispatch(getTemplateLineSettings(payload, uuid)),
  getCustomFields: (payload, productIds) => dispatch(productCustomFields(payload, productIds)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BarcodeActions);  